/** Product template communication config (API v2 shape: optional email / SMS blocks). */
export class ProductCommunicationChannelConfiguration {
  email?: ProductEmailCommunicationChannelConfiguration;
  sms?: ProductSmsCommunicationChannelConfiguration;

  constructor(json: Record<string, unknown>) {
    const email = json['email'] as Record<string, unknown> | undefined;
    const sms = json['sms'] as Record<string, unknown> | undefined;
    this.email = email ? new ProductEmailCommunicationChannelConfiguration(email) : undefined;
    this.sms = sms ? new ProductSmsCommunicationChannelConfiguration(sms) : undefined;
  }
}

export class ProductEmailCommunicationChannelConfiguration {
  templateId: string;
  subject: string;
  attachPdf: boolean;

  constructor(json: Record<string, unknown>) {
    this.templateId = String(json['templateId'] ?? '');
    this.subject = String(json['subject'] ?? '');
    this.attachPdf = Boolean(json['attachPdf'] ?? false);
  }
}

export class ProductSmsCommunicationChannelConfiguration {
  messageTemplate: string;

  constructor(json: Record<string, unknown>) {
    this.messageTemplate = String(json['messageTemplate'] ?? '');
  }
}
